import { Routes, Route } from "react-router-dom";
import { Form, NewPassword, ResetPassword } from "../../components";
import {
  ValidateUser,
  Register,
  DeliveryConfirmation,
  ImpersonationLanding,
  AnonymousOffer,
  TokenAcceptPage,
  CompanyReviewPage,
} from "../../containers";

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="/register" element={<Register />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/new-password" element={<NewPassword />} />
      <Route path="/validate-user" element={<ValidateUser />} />
      <Route
        path="/deliveries/token/:token"
        element={<DeliveryConfirmation />}
      />
      <Route
        path="/purchase-orders/token/:token"
        element={<TokenAcceptPage />}
      />
      <Route path="/company-review/:token" element={<CompanyReviewPage />} />
      <Route path="/order-invitations/:token" element={<AnonymousOffer />} />
      <Route path="/impersonate" element={<ImpersonationLanding />} />
      <Route path="/" element={<Form />} />
      <Route path="*" element={<Form />} />
    </Routes>
  );
};

export default AuthRoutes;
